// src/pages/Dashboard.js
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import Dropzone from "components/Dropzone_file";
import { GradientButton } from "components/GradientButton";
const ImportInformationPawn = ({ className }) => {
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleFileValidation = (files) => {
    // ใช้ Array.from เพื่อแปลง files เป็น Array หากไม่ใช่
    const fileArray = Array.isArray(files) ? files : Array.from(files);

    const maxFileSize = 10 * 1024 * 1024; // 10 MB
    const invalidFiles = fileArray.filter((file) => {
      // ตรวจสอบว่า file มีค่าและมี property 'size' หรือไม่
      if (!file || !file.size) return true;
      return (
        file.size > maxFileSize ||
        (file.name && !file.name.match(/\.(xls|xlsx)$/))
      );
    });

    const validFiles = fileArray
      .map((file) => {
        if (!file || !file.name) {
          return null; // ถ้าไม่มีชื่อไฟล์ ให้ส่ง null
        }
        return {
          file,
          name: file.name,
          status: "Loading",
        };
      })
      .filter((file) => file !== null);
    setUploadedFiles((prev) => [...prev, ...validFiles]);
    setError1(null);
    return true;
  };

  // อัปโหลดไฟล์ Backend
  const handleUpload = async () => {
    if (uploadedFiles.length === 0) {
      setError1("กรุณาอัปโหลดไฟล์ก่อนนำเข้า");
      return;
    }

    try {
      const formData = new FormData();
      uploadedFiles.forEach(({ file }) => formData.append("files[]", file));

      const response = await fetch("/api/import", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("การอัปโหลดล้มเหลว");
      }

      const result = await response.json();
      setUploadedFiles((prev) =>
        prev.map((file) => ({ ...file, status: "Complete" }))
      );

      alert("นำเข้าข้อมูลสำเร็จ!");
    } catch (error) {
      setUploadedFiles((prev) =>
        prev.map((file) => ({ ...file, status: "Failed" }))
      );
      setError1(error.message);
    }
  };

  return (
    <div className={className}>
      <Grid container spacing={10} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            นำเข้าข้อมูลขายฝาก
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={10} style={{ display: "flex", justifyContent: "center" }}>
        <Grid item style={{ width: "40%" }}>
          <Dropzone
            files={files1}
            setFiles={(newFiles) => {
              if (handleFileValidation(newFiles)) {
                setFiles1(newFiles);
              }
            }}
            setError={setError1}
          />
          {error1 && <Typography color="error">{error1}</Typography>}
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ marginTop: "16px" }}>
        {uploadedFiles.map((file, index) => (
          <Grid
            container
            key={index}
            style={{
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid #ccc",
            }}
          >
            <Grid item xs={8}>
              <Typography>{file.name}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                style={{
                  color:
                    file.status === "Complete"
                      ? "green"
                      : file.status === "Failed"
                      ? "red"
                      : "blue",
                }}
              >
                {file.status}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <GradientButton
          variant="contained"
          color="primary"
          onClick={handleUpload}
          style={{ marginTop: "16px" }}
        >
          นำเข้าข้อมูล
        </GradientButton>
      </Grid>
    </div>
  );
};

export default ImportInformationPawn;
